"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenChatBtn = void 0;
var _react = _interopRequireDefault(require("react"));
var _I18n = require("design_system/I18n");
var _MessageIcon = require("./MessageIcon");
var _hooks = require("./hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OpenChatBtn = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = (0, _I18n.useI18nContext)();
  const isExpanded = (0, _hooks.useIsExpandedText)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "fixed w-full flex bottom-16 right-16 justify-end z-10"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "rounded-full border-solid border-2 border-transparent flex items-center transition-[max-width] duration-[350ms] ease-in-out overflow-hidden",
    style: {
      background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(49.21deg, #365FC1 15.3%, #3667E9 50.47%, #638EFF 76.27%) border-box",
      maxWidth: isExpanded ? "145px" : "52px",
      padding: isExpanded ? "9px 16px 7px 16px" : "9px 8px 7px 8px",
      columnGap: isExpanded ? "10px" : "0px"
    },
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_MessageIcon.MessageIcon, {
    className: "shrink-0 w-32 h-32",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "text-primary-3667e9 whitespace-nowrap text-14 font-500",
    style: {
      opacity: isExpanded ? 1 : 0
    }
  }, t("Ask Kora"))));
};
exports.OpenChatBtn = OpenChatBtn;